import './Home.css'
import { useEffect } from "react";
import SeriesPanel from "../../../series/SeriesPanel.jsx";
// import Banner from './Banner.jsx';


// import BooksContent from "../books/Books";
// import BlogUpdate from "../../../forms/blog-updates/BlogUpdate";
export default function HomeContent({ comingSoonBook, bookList }) {
    useEffect(() => {
        document.title = 'Home - Scott A. Young';
    }, []);


    return (
        <>
            <div className="home-page">
		{/*<Banner />*/}
				
				<SeriesPanel />
            </div>
        </>

    )
}
